var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "validation-observer",
        { ref: "legalEntityForm" },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.saveLegalEntityForm($event)
                }
              }
            },
            [
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/3 w-full mb-2" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "CNPJ", "label-for": "cnpj" } },
                      [
                        _c("validation-provider", {
                          attrs: { name: "cnpj" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: ["##.###.###/####-##"],
                                        expression: "['##.###.###/####-##']"
                                      }
                                    ],
                                    attrs: {
                                      id: "cnpj",
                                      state: errors.length > 0 ? false : null,
                                      name: "register-cnpj"
                                    },
                                    model: {
                                      value: _vm.legalEntity.cnpj,
                                      callback: function($$v) {
                                        _vm.$set(_vm.legalEntity, "cnpj", $$v)
                                      },
                                      expression: "legalEntity.cnpj"
                                    }
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-2/3 w-full mb-2" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: "Razão Social",
                          "label-for": "company_name"
                        }
                      },
                      [
                        _c("validation-provider", {
                          attrs: { name: "Razão Social", rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-input", {
                                    staticClass: "required",
                                    attrs: {
                                      id: "company_name",
                                      state: errors.length > 0 ? false : null,
                                      name: "company_name"
                                    },
                                    model: {
                                      value: _vm.legalEntity.company_name,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.legalEntity,
                                          "company_name",
                                          $$v
                                        )
                                      },
                                      expression: "legalEntity.company_name"
                                    }
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "vx-row mb-2" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/3 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: "Nome Fantasia",
                          "label-for": "trading_name"
                        }
                      },
                      [
                        _c("validation-provider", {
                          attrs: { name: "Nome Fantasia", rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-input", {
                                    staticClass: "required",
                                    attrs: {
                                      id: "trading_name",
                                      state: errors.length > 0 ? false : null,
                                      name: "trading_name"
                                    },
                                    model: {
                                      value: _vm.legalEntity.trading_name,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.legalEntity,
                                          "trading_name",
                                          $$v
                                        )
                                      },
                                      expression: "legalEntity.trading_name"
                                    }
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/5 w-full" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Sigla", "label-for": "short_name" } },
                      [
                        _c("validation-provider", {
                          attrs: { name: "short_name" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "short_name",
                                      state: errors.length > 0 ? false : null,
                                      name: "short_name"
                                    },
                                    model: {
                                      value: _vm.legalEntity.short_name,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.legalEntity,
                                          "short_name",
                                          $$v
                                        )
                                      },
                                      expression: "legalEntity.short_name"
                                    }
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/5 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: "Número Interno",
                          "label-for": "trading_name"
                        }
                      },
                      [
                        _c("validation-provider", {
                          attrs: { name: "internal_number" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "internal_number",
                                      state: errors.length > 0 ? false : null,
                                      name: "internal_number"
                                    },
                                    model: {
                                      value: _vm.legalEntity.internal_number,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.legalEntity,
                                          "internal_number",
                                          $$v
                                        )
                                      },
                                      expression: "legalEntity.internal_number"
                                    }
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/5 w-full" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Ativo", "label-for": "active" } },
                      [
                        _c("validation-provider", {
                          attrs: { name: "outsourced" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-checkbox", {
                                    staticClass: "mr-0 mt-50",
                                    attrs: {
                                      name: "active",
                                      switch: "",
                                      inline: "",
                                      value: "A",
                                      "unchecked-value": "I"
                                    },
                                    model: {
                                      value: _vm.legalEntity.status,
                                      callback: function($$v) {
                                        _vm.$set(_vm.legalEntity, "status", $$v)
                                      },
                                      expression: "legalEntity.status"
                                    }
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/1 w-full mb-2" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: "Mantenedora",
                          "label-for": "main_office_id"
                        }
                      },
                      [
                        _c("validation-provider", {
                          attrs: { name: "main_office_id" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c(
                                    "v-select",
                                    {
                                      attrs: {
                                        options: _vm.mainOfficeList,
                                        label: "trading_name"
                                      },
                                      model: {
                                        value: _vm.mainOffice,
                                        callback: function($$v) {
                                          _vm.mainOffice = $$v
                                        },
                                        expression: "mainOffice"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "no-options" },
                                          slot: "no-options"
                                        },
                                        [_vm._v("Nenhum registro encontrado!")]
                                      )
                                    ]
                                  ),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              !_vm.isComplement
                ? _c("div", { staticClass: "vx-row mt-2 mb-2" }, [
                    _c(
                      "div",
                      { staticClass: "vx-col w-full flex justify-end" },
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "ripple",
                                rawName: "v-ripple.400",
                                value: "rgba(255, 255, 255, 0.15)",
                                expression: "'rgba(255, 255, 255, 0.15)'",
                                modifiers: { "400": true }
                              }
                            ],
                            staticClass: "mr-2 float-right",
                            attrs: {
                              variant: "primary",
                              disabled: !_vm.validateForm,
                              type: "submit"
                            }
                          },
                          [_vm._v(" Salvar ")]
                        ),
                        _vm.buttonNewUnitShow
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "ripple",
                                    rawName: "v-ripple.400",
                                    value: "rgba(255, 255, 255, 0.15)",
                                    expression: "'rgba(255, 255, 255, 0.15)'",
                                    modifiers: { "400": true }
                                  }
                                ],
                                staticClass: "mr-1 float-right",
                                attrs: { variant: "outline-primary" },
                                on: { click: _vm.addNewUnit }
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("new_unit")) + " ")]
                            )
                          : _vm._e(),
                        _vm.showButtonImportUnit
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "ripple",
                                    rawName: "v-ripple.400",
                                    value: "rgba(255, 255, 255, 0.15)",
                                    expression: "'rgba(255, 255, 255, 0.15)'",
                                    modifiers: { "400": true }
                                  }
                                ],
                                staticClass: "mr-1 float-right",
                                attrs: { variant: "outline-primary" },
                                on: {
                                  click: function($event) {
                                    _vm.showImportModal = true
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("action.import_unit")) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "ripple",
                                rawName: "v-ripple.400",
                                value: "rgba(255, 255, 255, 0.15)",
                                expression: "'rgba(255, 255, 255, 0.15)'",
                                modifiers: { "400": true }
                              }
                            ],
                            staticClass: "float-right",
                            attrs: { variant: "outline-secondary" },
                            on: { click: _vm.cancel }
                          },
                          [_vm._v(" Voltar ")]
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _vm.legalEntity.id !== null
        ? _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col sm:w-1/1 w-full mb-2" },
              [
                _c("LegalEntitySponsor", {
                  key: _vm.legalEntity,
                  attrs: {
                    services: _vm.services,
                    legalEntity: _vm.legalEntity
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _c(
        "vs-popup",
        {
          attrs: { title: "Importar Unidades", active: _vm.showImportModal },
          on: {
            "update:active": function($event) {
              _vm.showImportModal = $event
            }
          }
        },
        [
          _c("ImportExcel", {
            attrs: {
              onSuccess: _vm.onImportUnitSuccess,
              templateMessage:
                "Clique aqui para baixar um modelo para <br/> o preenchimento de importação de pessoa jurídica.",
              accept: ".xlsx, .xls"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }